import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '../../shared/services/notification.service';
import { ProductService } from '../../shared/services/product.service';
import { RestApiService } from '../../shared/services/restapi.service';
import { UserService } from '../../shared/services/user.service';
import { getSubdomain } from 'tldts';
import { ConfigService } from '../../shared/services/config.service';
import { ValidateKeywordService } from '../../shared/services/validatekeyword.service';
import { UserServiceModal } from 'src/app/modals/userservice.modal';
import { Title } from '@angular/platform-browser';
import { UtilityService } from '../../shared/services/utility.service';
import { RegexService } from '../../shared/services/regex.service';
import * as _ from 'lodash';
import { DefaultCountry } from 'src/app/constant';
declare const Object: {
  keys<T extends {}>(object: T): (keyof T)[]
};

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  public userInfo: any = {
    firstname: '',
    lastname: '',
    email: '',
    username: '',
    password: '',
    confirmpassword: '',
    DefaultShippingAddress: {
      Street1: '',
      Street2: '',
      City: '',
      Region: '',
      CountryCode: '',
      PostalCode: '',
    },
    phoneNumber: '',
    BirthYear: 2000,
    BirthMonth: 1,
    BirthDay: 1,
  };
  days = [];
  months = [];
  years = [];
  userService: UserServiceModal;
  public loadingDetails: boolean = false;
  public UserNameCheck: boolean = false;
  public EmailCheck: boolean = true;
  showError: boolean = false;
  StatesResponse: [];
  StateNameToggel: boolean = false;
  constructor(
    public user: UserService,
    private router: Router,
    public notificationService: NotificationService,
    public apiService: RestApiService,
    public translate: TranslateService,
    public itemsService: ProductService,
    public configService: ConfigService,
    public validateKeywordService: ValidateKeywordService,
    public titleService: Title,
    public utilityService: UtilityService,
    public regexService: RegexService,
    ) {
      this.userService = user.userServiceModal;
      this.days = this.utilityService.birthDays();
      this.months = this.utilityService.birthMonths();
      this.years = this.utilityService.birthYears();
    }

  ngOnInit(): void {
    this.translate.get('global_Company_Title').subscribe((text: string) => {
      this.titleService.setTitle(this.translate.instant('pagetitle_signup') + ' | ' + text);
    });
    if (Object.keys(this.userService.customerData).length || this.userService.guestUserData.Email) {
      this.notificationService.error('message_', 'you_are_already_logged_in');
      this.router.navigate(['products/all'], {skipLocationChange: false});
    }
    this.getStates();
  }


  createCustomer() {
    if (!(this.UserNameCheck && !this.EmailCheck)) { return; }
    this.loadingDetails = true;
    this.userService.customerTypeID = 2;
    const request = {
      CustomerType: 2,
      BirthDate: new Date(
        (this.userInfo.BirthYear || 2000),
        (this.userInfo.BirthMonth || 1),
        (this.userInfo.BirthDay || 1),
      ).toDateString(),
      EmailAddress: this.userInfo.email,
      FirstName: this.userInfo.firstName,
      LastName: this.userInfo.lastName,
      Password: this.userInfo.password,
      PrimaryAddress: {
        Street1: this.userInfo.DefaultShippingAddress.Street1,
        Street2: this.userInfo.DefaultShippingAddress.Street2,
        Region: this.userInfo.DefaultShippingAddress.Region || this.userService.regionMainState || 'UT',
        City: this.userInfo.DefaultShippingAddress.City,
        CountryCode: this.configService.commonData.selectedCountry || DefaultCountry,
        PostalCode: this.userInfo.DefaultShippingAddress.PostalCode,
      },
      DefaultShippingAddress: {
        Street1: this.userInfo.DefaultShippingAddress.Street1,
        Street2: this.userInfo.DefaultShippingAddress.Street2,
        PostalCode: this.userInfo.DefaultShippingAddress.PostalCode,
        City: this.userInfo.DefaultShippingAddress.City,
        Region: this.userInfo.DefaultShippingAddress.Region,
        CountryCode: this.configService.commonData.selectedCountry || DefaultCountry,
      },
      SponsorId: this.userService.enrollerInfo.CustomerId || 2,
      BackOfficeId: this.userService.enrollerInfo.CustomerId || 2,
      Username: this.userInfo.username,
      PrimaryPhone: this.userInfo.phoneNumber,
      TextPhone: this.userInfo.phoneNumber,
      WebAlias: this.userInfo.username,
      isGuest: true
    };
    this.apiService.createCustomer(request).subscribe((result) => {
      this.loadingDetails = false;
      try {
        if (result.Data && result.Message == "Success") {
          this.loginFunction(this.userInfo.email, this.userInfo.password);
          this.userService.newUser = true;
          // this.userInfo = {};
          this.notificationService.success('Success', 'customer_created_successfully');
        } else {
          this.notificationService.error('error_', result.ErrorDescription);
        }
      } catch (ex) {
        this.notificationService.error('error_', 'error_occured_try_again');
      }
    },
    err => {
      // Do stuff whith your error
      this.loadingDetails = false;
    },
    () => {
      
    });
  }

  verifyUsername(username: string) {
    this.UserNameCheck = false;
    if (this.userInfo.username) {
      const isValidPost = this.validateKeywordService.CheckValidation(this.configService.localSettings.Global.blockword, username);
      if (isValidPost && !(isValidPost.isvalid)) {
        this.notificationService.error('error_', this.translate.instant('username_not_available_'));
        this.UserNameCheck = false;
        this.userInfo.username = '';
      } else {

        this.loadingDetails = true;

        this.apiService.validateUsername(this.userInfo.username).subscribe((result) => {
          this.loadingDetails = false;
          try {
            if (result.Data) {
              this.UserNameCheck = true;
              this.notificationService.success('success', this.translate.instant('username_available_'));
            } else {
              this.notificationService.error('error_', this.translate.instant('username_not_available_'));
              this.userInfo.username = '';
            }
          } catch (ex) {
            this.notificationService.error('error_', this.translate.instant('error_occured_try_again'));
          }
        },
          err => {
            // Do stuff whith your error
            this.loadingDetails = false;
          },
          () => {
            
          });
      }
    }
  }

  loginFunction(userName, pass) {
    this.loadingDetails = true;
    const loginrequest = {
      granttype: 'password',
      scope: 'office',
      username: userName,
      password: pass
    };
    this.apiService.Login(loginrequest).subscribe(
       (result) => {
        if (result) {
          try {
            localStorage.setItem('isLoggedIn', 'true');
            this.apiService.getCustomer().subscribe((data) => {
              this.loadingDetails = false;
              if (data && data.Data) {
                localStorage.setItem('user', JSON.stringify(data.Data));
                this.userService.customerData = data.Data;
                this.userService.customerTypeID = this.userService.customerData.CustomerType;
                // Ensure both storages are set for iOS compatibility
                sessionStorage.setItem('selectedCustomerTypeID', this.userService.customerTypeID.toString());
                localStorage.setItem('userService', JSON.stringify(this.userService));
                if (!this.utilityService.isEmptyObject(this.userService.customerData.DefaultShippingAddress)) {
                  this.user.setShippingAddress();
                } else {
                  this.userService.shippingAddress = new UserServiceModal().newshippingAddress;
                }
                if (this.userService.customerData.WebAlias) {
                  this.apiService.validateWebAlias(this.userService.customerData.WebAlias).subscribe((res: any) => {
                    if (!res.Data) {
                      this.userService.WebAlias = this.userService.customerData.WebAlias;
                      this.loginredirect(this.userService.WebAlias);
                    }
                  }, (error) => {
                    if (error.Data && !error.Data.WebAlias) {
                      this.notificationService.error('error_', 'webalias_not_exists');
                      return false;
                    }
                  },
                    () => {
                      
                    });
                }
                else if (this.userService.customerData.SponsorId) {
                  this.apiService.getSearchCustomerDetail(this.userService.customerData.SponsorId).subscribe((resp: any) => {
                    if (resp.Data) {
                      this.apiService.validateWebAlias(resp.Data.WebAlias).subscribe((res: any) => {
                        if (res.Data) {
                          this.userService.WebAlias = resp.Data.WebAlias;
                          this.loginredirect(this.userService.WebAlias);
                        }
                      }, (error) => {
                        if (error.Data && !error.Data) {
                          this.notificationService.error('error_', 'webalias_not_exists');
                          return false;
                        }
                      },
                        () => {
                          
                        });
                    }
                  }, (error) => {
                    if (error.Data && !error.Data.WebAlias) {
                      this.notificationService.error('error_', 'webalias_not_exists');
                      return false;
                    }
                  },
                    () => {
                      
                    });
                }
              } else {
                this.notificationService.error('error_', 'error_occured_try_again');
              }
            }, err => {
              this.notificationService.error('error_', 'error_occured_try_again');
              this.loadingDetails = false;
            },
              () => {
                
              });
          } catch (successEx) {
            this.notificationService.error('error_', 'error_occured_try_again');
            this.loadingDetails = false;
            console.error('ex', successEx);
          }
        } else {
          this.loadingDetails = false;
          this.notificationService.error('error_', 'error_occured_try_again');
        }
      }, err => {
        this.loadingDetails = false;
        this.notificationService.error('error_', 'error_occured_try_again');
      },
      () => {
        
      });
  }

  loginredirect(alias) {
    let newUrl: string = window.location.origin;
    const webAlias = alias;
    // const subdomain = getSubdomain(window.location.host);
    if (webAlias) {
      newUrl = `${newUrl}/${webAlias}`;
    } else {
      newUrl = `${newUrl}/samspace`;
    }

    if (this.itemsService.selectedPacks.length || this.itemsService.selectedOrderItems.length) {
      this.userService.checkItems = true;

      newUrl = `${newUrl}/checkout`;
    } else if (this.itemsService.selectedAutoOrderItems.length) {
      this.userService.checkItems = true;

      newUrl = `${newUrl}/products/all`;
    } else {
      newUrl = `${newUrl}/products/all`; 
    }
    window.location.assign(newUrl);
  }

  getStates() {
    this.apiService.getStates(this.configService.commonData.selectedCountry || DefaultCountry).subscribe((result) => {
      sessionStorage.setItem(DefaultCountry + 'State', JSON.stringify(result.Data));
      if (result.Data && result.Data.length > 0) {
        this.StatesResponse = result.Data;          
        if (this.configService.commonData.selectedCountry== DefaultCountry || this.configService.commonData.selectedCountry == 'us') {
          if(this.userInfo?.DefaultShippingAddress){
            this.userInfo.DefaultShippingAddress.Region = "UT"
          }
          result.Data.forEach((x => {
            if (x.StateCode == "UT") {
              this.userService.mailingAddress.StateName =
                this.userService.mailingAddress.StateName || result.Data[0].StateName;
            }
          }));
        }
        if (!this.StateNameToggel) {
          this.getStateName(false);
          this.StateNameToggel = true;
        }
      }
    },
      (error) => {
      }, () => {

      });
  }

  getStateName(isMailingAddress) {
      if (isMailingAddress) {
        this.userService.mailingAddress.StateName = _.filter(
          this.StatesResponse, (state: any) => {
            return (
              state.StateCode ===
              (this.userService.mailingAddress.State || this.userService.defaultState)
            );
          }
        )[0].StateName;
        if (this.userService.paymentMethods.length > 0) {
          this.userService.paymentMethods = [];
          this.notificationService.warning('warn_', 'unifiedapplication_fill_payment_again_state');
        }
      } else {
          //@ts-ignore
          this.userService.shippingAddress?.Region = _?.filter(
          this.StatesResponse, (state: any) => {
            return (
              state.StateCode ===
              (this.userService.shippingAddress?.Region || this.userService?.defaultState)
            );
          }
        )[0]?.StateCode;
      }
    }

  // For check android Mobile only
  validEmailData(value) {
    this.userInfo.email = value.replace(/\s/g, '');
    this.verifyUserNameAndEmail();
  }

  verifyUserNameAndEmail() {
    var filter = new RegExp('^([\\w-\\.+]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([\\w-]+\\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\\]?)$');
    if (this.userInfo.email && filter.test(this.userInfo.email)) {
      this.apiService.validateEmailAddress({ EmailAddress: this.userInfo.email }).subscribe((result) => {
        if (result.Data) {
          this.EmailCheck = false;
          this.notificationService.success('success', 'email_available_');
        } else {
          this.notificationService.error('error_', 'error_email_exists');
          this.userInfo.email = '';
          this.EmailCheck = true;
        }
      });
    }
  }

  regexValidateZip(countrycode) {
    const regxExp = this.regexService.getRegex(countrycode.toUpperCase());
    const filter = new RegExp(regxExp);
    if (filter.test(this.userInfo.DefaultShippingAddress.PostalCode)) {
      this.showError = false;
    }
    else {
      this.showError = true;
    }
  }
validatewebalias(request: any) {
     this.UserNameCheck = false;
    if (!request) {
      return;
    }
    this.apiService.validateWebAlias(request).subscribe((res: any) => {
      if (res.Data) {
        this.UserNameCheck = true;
        this.notificationService.success("success", "Webalias Available")
      } else {
        this.notificationService.error(
          "error_",
          "webalias Not Available"
        );
        this.UserNameCheck = false;
        this.userInfo.username = '';
      }
    },
      (error) => {
        if (error.Data && !error.Data.WebAlias) {
          this.notificationService.error(
            "error_",
            "webalias_not_exists",
          );
          return false;
        }
      },
      () => { },)
  }
}
